import * as Onboarding from '../_layout/OnboardingComponents'
import { CompanyConfirmationAdminContent } from './_layout/CompanyConfirmationAdminContent'
import { CompanyConfirmationAdminSideMenu } from './_layout/CompanyConfirmationAdminSideMenu'

function CompanyConfirmationAdminPage() {
  return (
    <Onboarding.Container>
      <Onboarding.ContainerContent>
        <CompanyConfirmationAdminContent />
      </Onboarding.ContainerContent>

      <Onboarding.ContainerSideMenu>
        <CompanyConfirmationAdminSideMenu />
      </Onboarding.ContainerSideMenu>
    </Onboarding.Container>
  )
}

export default CompanyConfirmationAdminPage
